export function header() {


    var header = document.getElementById("masthead");
    // construct an instance of Headroom, passing the element
    var headroom  = new Headroom(header, {
        "offset": 200,
        "tolerance": 5,
        "classes": {
            "initial": "headroom",
            "pinned": "slide-down",
            "unpinned": "slide-up"
        }
    });
    // initialise
    headroom.init();
}